import { IconType } from 'react-icons';
import {
    MdOutlineAccountBalance,
    MdOutlineAccountBalanceWallet,
    MdOutlineAccountTree,
    MdOutlineAddLink,
    MdOutlineAdminPanelSettings,
    MdOutlineApartment,
    MdOutlineAssignmentInd,
    MdOutlineAttachFile,
    MdOutlineBalance,
    MdOutlineBlock,
    MdOutlineBuild,
    MdOutlineCalculate,
    MdOutlineCategory,
    MdOutlineContentCopy,
    MdOutlineDeleteForever,
    MdOutlineEditNote,
    MdOutlineEngineering,
    MdOutlineEventRepeat,
    MdOutlineFactCheck,
    MdOutlineFileDownload,
    MdOutlineFlag,
    MdOutlineGavel,
    MdOutlineGridOn,
    MdOutlineGroupAdd,
    MdOutlineGroups,
    MdOutlineHistoryEdu,
    MdOutlineInventory2,
    MdOutlineLibraryBooks,
    MdOutlineLinkOff,
    MdOutlineListAlt,
    MdOutlineLocalShipping,
    MdOutlineLockOpen,
    MdOutlineMailOutline,
    MdOutlineManageAccounts,
    MdOutlineMenuBook,
    MdOutlineNoteAdd,
    MdOutlineNotificationsNone,
    MdOutlinePayments,
    MdOutlinePeopleAlt,
    MdOutlinePlaylistAdd,
    MdOutlinePostAdd,
    MdOutlinePrint,
    MdOutlineQueryStats,
    MdOutlineQuestionAnswer,
    MdOutlineReceiptLong,
    MdOutlineRocketLaunch,
    MdOutlineSend,
    MdOutlineSettings,
    MdOutlineSettingsSuggest,
    MdOutlineShoppingBag,
    MdOutlineStraighten,
    MdOutlineSwapHoriz,
    MdOutlineSync,
    MdOutlineTag,
    MdOutlineTune,
    MdOutlineUndo,
    MdOutlineUploadFile,
    MdOutlineVerified,
    MdOutlineWarehouse,
} from 'react-icons/md';

/**
 * Иконки меню «Создать документ». Конфиг (DocumentActionsReact.xml → ClientOptions.menu)
 * ссылается на иконку логическим kebab-case именем — словарь отвязывает конфиги от
 * конкретной иконочной библиотеки. Неизвестное или пустое имя тихо падает в дефолт.
 */
const MENU_ICONS: Record<string, IconType> = {
    // документы-заявки
    'request-new': MdOutlinePostAdd,
    'calendar-plan': MdOutlineEventRepeat,
    flag: MdOutlineFlag,
    'plan-list': MdOutlineListAlt,
    law: MdOutlineBalance,
    'list-add': MdOutlinePlaylistAdd,
    'question-chat': MdOutlineQuestionAnswer,
    verified: MdOutlineVerified,
    'price-stats': MdOutlineQueryStats,
    committee: MdOutlineGroups,
    gavel: MdOutlineGavel,
    contract: MdOutlineHistoryEdu,
    // справочники
    company: MdOutlineApartment,
    inventory: MdOutlineInventory2,
    warehouse: MdOutlineWarehouse,
    people: MdOutlinePeopleAlt,
    'person-assignment': MdOutlineAssignmentInd,
    engineering: MdOutlineEngineering,
    print: MdOutlinePrint,
    'edit-note': MdOutlineEditNote,
    tree: MdOutlineAccountTree,
    // финансы
    swap: MdOutlineSwapHoriz,
    payments: MdOutlinePayments,
    wallet: MdOutlineAccountBalanceWallet,
    calculate: MdOutlineCalculate,
    bank: MdOutlineAccountBalance,
    receipt: MdOutlineReceiptLong,
    // исполнение
    shipping: MdOutlineLocalShipping,
    'fact-check': MdOutlineFactCheck,
    // импорт
    'upload-file': MdOutlineUploadFile,
    sync: MdOutlineSync,
    category: MdOutlineCategory,
    rocket: MdOutlineRocketLaunch,
    ruler: MdOutlineStraighten,
    library: MdOutlineLibraryBooks,
    tag: MdOutlineTag,
    tune: MdOutlineTune,
    'settings-suggest': MdOutlineSettingsSuggest,
    // системные
    build: MdOutlineBuild,
    'group-add': MdOutlineGroupAdd,
    'admin-roles': MdOutlineAdminPanelSettings,
    // операции карточки документа (меню «Действия»)
    attach: MdOutlineAttachFile,
    'file-download': MdOutlineFileDownload,
    bell: MdOutlineNotificationsNone,
    mail: MdOutlineMailOutline,
    copy: MdOutlineContentCopy,
    link: MdOutlineAddLink,
    unlink: MdOutlineLinkOff,
    unlock: MdOutlineLockOpen,
    send: MdOutlineSend,
    undo: MdOutlineUndo,
    'user-swap': MdOutlineManageAccounts,
    block: MdOutlineBlock,
    delete: MdOutlineDeleteForever,
    // иконки разделов
    'shopping-bag': MdOutlineShoppingBag,
    book: MdOutlineMenuBook,
    table: MdOutlineGridOn,
    settings: MdOutlineSettings,
};

export const DEFAULT_ACTION_ICON: IconType = MdOutlineNoteAdd;
export const DEFAULT_SECTION_ICON: IconType = MdOutlineListAlt;

export const resolveMenuIcon = (name: string | undefined, fallback: IconType): IconType =>
    (name && MENU_ICONS[name]) || fallback;
